module.exports = __webpack_public_path__ + "img/sweden.52b40eb3.svg";